<template>
    <div class="container">
        <div class="columns">
            <div class="column is-2 menu-vert">
                <MenuVert :currentactive="'approve-order'" />
            </div>
            <div class="column is-10" style="margin-top:25px;">
                <div class="columns">
                    <label>{{ $t ('filter-by-basket-number') }}</label>
                    <b-input v-model="basketNumber"></b-input>
                </div>
                <b-tabs v-model="activeTab">
                    <b-tab-item :label="$t ('open-orders')">
                        <OrderTable
                            :orders="openOrders"
                            :basketNumber="basketNumber"
                            :perPage="perPage"
                            :columns="0xF7"
                            >
                        </OrderTable>
                    </b-tab-item>

                    <b-tab-item :label="$t ('in-process-orders')">
                        <OrderTable
                            :orders="inProcessOrders"
                            :basketNumber="basketNumber"
                            :perPage="perPage"
                            :columns="0x97"
                            >
                        </OrderTable>
                    </b-tab-item>

                    <b-tab-item :label="$t ('finished-orders')">
                        <OrderTable
                            :orders="finishedOrders"
                            :basketNumber="basketNumber"
                            :perPage="perPage"
                            :columns="0xE7"
                            >
                        </OrderTable>
                    </b-tab-item>
                </b-tabs>
            </div>
        </div>
    </div>
</template>

<script>
import Vue                  from "vue"
import { mapGetters }       from "vuex"
import axios                from "axios"
import MenuVert             from "@/components/MenuVert"
import OrderTable           from "./OrderTable"

export default {
    name: "ApproveOrder",
    data () {
        return {
            basketNumber: "",
            orders: [],
            loading: true,
            activeTab: 0,
            perPage: 25,
        }
    },
    components:{
        MenuVert, OrderTable
    },
    computed: {
        ...mapGetters(["getCurrentCompany", "getUserToken", "getCompany"]),
        filteredOrders () {
            return this.orders.filter
                (o => o.basket_number.indexOf (this.basketNumber) >= 0)
        },
        openOrders () {
            return this.filteredOrders.filter (o => (o.status <= 2))
        },
        inProcessOrders () {
            return this.filteredOrders.filter (o => ((o.status > 2) && o.status < 5))
        },
        finishedOrders () {
            return this.filteredOrders.filter (o => (o.status >= 5))
        },
        statusAsText() {
            return {
                0  : this.$t ("open"),
                1  : this.$t ("?"),
                2  : this.$t ("wait for aprooval"),
                3  : this.$t ("ready"),
                4  : this.$t ("analyzing"),
                5  : this.$t ("ready for production"),
                6  : this.$t ("error")
            }
        }
    },
    methods: {
        findOrder (orders, basket_number) {
            for (let i = 0; i < orders.length; i++) {
                let order = orders [i]
                if (order.basket_number == basket_number) {
                    return order
                }
            }
            return undefined
        },
        updateState (basket_number) {
            let order = this.findOrder (this.orders, basket_number)
            Vue.set (order, "query_pending", true)
            let uri  = "/vue/basket/" + basket_number + "/status/"
            let self = this
            axios.get (uri, {
                headers: { Authorization: "Token " + this.getUserToken}
            }).then (response => {
                let rdata = response.data
                if (rdata.status == false) {
                    self.$toastr.open({
                        message: rdata.messages.join ("<br />"),
                        type: 'is-error'
                    })
                } else {
                    order.status             = rdata.data.order_status
                    order.last_status_update = rdata.data.last_status_update
                }
                order.query_pending = false
            })
        },
        approveState (basket_number, approvalNumber) {
            let order = this.findOrder (this.orders, basket_number)
            Vue.set (order, "query_pending", true)
            let uri  = "/vue/basket/" + basket_number + "/approve/"
            let self = this
            axios.post (uri, {}, {
                headers: { Authorization: "Token " + this.getUserToken},
                params: { approvalNumber}
            }).then (response => {
                let rdata = response.data
                order.query_pending = false
                if (rdata.status == false) {
                    self.$toastr.open({
                        message: rdata.messages.join ("<br />"),
                        type: 'is-error'
                    })
                } else {
                    order.status             = rdata.data.order_status
                    order.last_status_update = rdata.data.last_status_update
                }
                order.query_pending = false
            })
        },
        resetState (basket_number) {
            let order = this.findOrder (this.openOrders, basket_number)
            Vue.set (order, "query_pending", true)
            let uri  = "/vue/basket/" + basket_number + "/reset/"
            let self = this
            axios.post (uri, {}, {
                headers: { Authorization: "Token " + this.getUserToken}
            }).then (response => {
                let rdata = response.data
                if (rdata.status == false) {
                    self.$toastr.open({
                        message: rdata.messages.join ("<br />"),
                        type: 'is-error'
                    })
                } else {
                    this.updateState (basket_number)
                }
                order.query_pending = false
            })
        },
        queryOrders (showOrder) {
            let uri  = "/vue/basket/list/"
            let self = this
            axios.get (uri, {
                headers: { Authorization: "Token " + this.getUserToken},
                params: {dealer: this.getCompany}
            }).then (response => {
                let rdata = response.data
                if (rdata.status == true) {
                    this.orders  = rdata.data.orders
                    showOrder    = showOrder || ""
                    if (showOrder.length) {
                        const order = this.findOrder (this.orders, showOrder)
                        if (order) {
                            this.basketNumber = showOrder
                            if (order.status <= 2) {
                                this.activeTab = 0
                            } else if (order.status <= 4) {
                                this.activeTab = 1
                            } else {
                                this.activeTab = 2
                            }
                        }
                    }
                } else {
                    self.$toastr.open({
                        message: rdata.messages.join ("<br />"),
                        type: 'is-error'
                    })
                }
            })
        }
    },
    beforeRouteUpdate (to, from, next) {
        this.queryOrders (to.query.order)
        next ()
    },
    mounted () {
        this.queryOrders (this.$route.query.order)
    }
}
</script>

<style scoped>
    label {
        padding: 0.5em 1em;
    }
</style>